
import { Vue, Component, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { ProgramPaths } from "@/enum/ProgramPaths";
import { sayfaUrunParcasi } from "@/utils/sayfaErisimi";

@Component({
  name: 'UrunlerInfo',
  name: 'ZirveCloudButton',
})
export default class UrunlerInfo extends Vue {
  urunler = [
    {
      id: 1,
      isim: "OfisPro",
      logo: require("../../assets/cloudicon.svg"),
      color: "purple--text text--darken-2",
      color2: "purple darken-2",
      btnColor: "white",
      route: ProgramPaths.ofispro,
      secili: false,
      authorizationKey: "ofis-pro",
    },
    {
      id: 2,
      isim: "İcraPro",
      logo: require("../../assets/icraprooldicon.svg"),
      color: "blue--text text--darken-2",
      color2: "blue darken-2",
      btnColor: "white",
      route: ProgramPaths.icrapro,
      secili: false,
      authorizationKey: "icra-pro",
    },
    {
      id: 3,
      isim: "e-İcraPro",
      logo: require("../../assets/eicraproicon.png"),
      color: "amber--text text--darken-4",
      color2: "amber darken-4",
      btnColor: "white",
      route: ProgramPaths.eicrapro,
      secili: false,
      authorizationKey: "eicra-pro",
    },
    {
      id: 4,
      isim: "DavaProWeb",
      logo: require("../../assets/davaprowebicon.svg"),
      color: "deep-orange--text text--darken-4",
      color2: "deep-orange darken-4",
      btnColor: "white",
      route: ProgramPaths.davapro,
      externalUrl: "https://giris.davapro.com/login",
      secili: false,
      authorizationKey: "dava-pro",
    },
    {
      id: 5,
      isim: "ArabulucuPro",
      logo: require("../../assets/arabulucuproicon.svg"),
      color: "light-blue--text text--darken-4",
      color2: "light-blue darken-4",
      btnColor: "white",
      route: ProgramPaths.arabulucupro,
      externalUrl: "https://www.arabulucupro.com/login",
      secili: false,
      authorizationKey: "arabulucu-pro",
    },
  ];

  get aktifUrun() {
    return this.urunler.find(urun => urun.secili) || this.urunler[0];
  }

  secimiDegis(urun: any) {
    // Harici uygulamalar (DavaProWeb, ArabulucuPro) yeni sekmede acilir;
    // mevcut sekmedeki aktif urun state'i degismemelidir.
    if (urun.externalUrl)
      return;
    this.urunler.forEach((x: any) => {
      x.secili = false;
    });
    urun.secili = true;
  }

  getRoute(id: number) {
    return this.urunler[id - 1].route;
  }

  /**
   * DEV-2113 — seçili ürün adresten okunur, her sayfa geçişinde yeniden. Önceden yalnız
   * bileşen kurulurken okunuyordu; uygulama içinden başka ürüne geçince (lisans ekranındaki
   * "… ekranına dön" gibi) üst çubuk eski ürünü göstermeye devam ediyordu. Lisans ve
   * "aktif değil" ekranlarında gelinen ürün (menüyle aynı kural); ürüne ait olmayan sayfada
   * seçim değişmez.
   */
  @Watch("$route", { immediate: true })
  onRouteChange(rota?: Route) {
    if (!rota) return;
    this.rotadanSec(rota);
  }

  rotadanSec(rota: { path: string; query?: Record<string, unknown> }) {
    const yol = "/" + sayfaUrunParcasi(rota.path, rota.query?.urun);
    const urun = this.urunler.find((u) => u.route === yol);
    if (urun) this.secimiDegis(urun);
  }
}
